import { render, staticRenderFns } from "./InviteURL.vue?vue&type=template&id=0b10ed14&"
import script from "./InviteURL.vue?vue&type=script&lang=ts&"
export * from "./InviteURL.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports